import { useEffect, useState } from 'react';

type Breakpoints = number[];

const getBreakpointIndex = (breakpoints: Breakpoints): number => {
  const width = window.innerWidth;
  const index = breakpoints.findIndex((bp) => width <= bp);
  return index === -1 ? breakpoints.length : index;
};

export const useResponsive = (breakpoints: Breakpoints) => {
  const [index, setIndex] = useState(() => getBreakpointIndex(breakpoints));

  useEffect(() => {
    const handleResize = () => {
      setIndex(getBreakpointIndex(breakpoints));
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [breakpoints]);

  return index;
};
